import { FilingFrequency } from '@/types/filings';
import { CountryCode } from '@/types/location';
import { RegistrationCategory } from '@/types/registrations';
import { z } from 'zod';

// Single registration object schema
export const registrationCreateSchema = z.object({
  country_code: z.enum(CountryCode, { message: 'Country is required' }),
  state_code: z.string().min(1, 'Jurisdiction is required'),
  filing_frequency: z.enum(FilingFrequency, { message: 'Filing frequency is required' }),
  type: z.enum(RegistrationCategory, { message: 'Category is required' }),
  registration_date: z.string().optional(),
  registration_email: z.email().optional(),
  username: z.string().optional(),
});

// Bulk create array schema (used by the API)
export const registrationCreateApiSchema = z.object({
  registrations: z.array(registrationCreateSchema),
});

export type RegistrationCreate = z.infer<typeof registrationCreateSchema>;
export type RegistrationCreatePayload = z.infer<typeof registrationCreateApiSchema>;
